"use client";

import "./InteractiveFeatureSection.scss";
import { useState } from "react";
import Image from "next/image";
import { Col, Container, Row } from "react-bootstrap";

const InteractiveFeatureSection = ({
  title,
  description,
  features = [],
  sectionClass = "",
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  if (!features.length) return null;

  const activeFeature = features[activeIndex];

  const renderHighlightedTitle = (title = "") => {
    const parts = title.split(/(".*?")/g);

    return parts.map((part, index) => {
      if (part.startsWith('"') && part.endsWith('"')) {
        return (
          <span key={index} className="highlight-font">
            {part.slice(1, -1)}
          </span>
        );
      }

      return part;
    });
  };

  return (
    <section className={`interactive-feature-section ${sectionClass}`}>
      <Container>
        <Row className="section-header align-items-center">
          <Col xxl={8} xl={6} lg={6} md={6}>
            <div className="text-wrapper">
              <h2 className="section-title">{renderHighlightedTitle(title)}</h2>
            </div>
          </Col>

          <Col xxl={4} xl={5} lg={4} md={4}>
            <div className="text-wrapper">
              <p className="section-description">{description}</p>
            </div>
          </Col>
        </Row>

        <Row className="section-content">
          <Col lg={5}>
            <ul className="feature-list">
              {features.map((item, index) => (
                <li
                  key={index}
                  className={activeIndex === index ? "active" : ""}
                  onMouseEnter={() => setActiveIndex(index)}
                  onFocus={() => setActiveIndex(index)}
                  onClick={() => setActiveIndex(index)}
                  tabIndex={0}
                  role="button"
                  aria-pressed={activeIndex === index}
                >
                  <span className="feature-bullet">•</span>
                  <span>{item.title}</span>
                </li>
              ))}
            </ul>
          </Col>

          <Col lg={7}>
            {activeFeature && (
              <div className="feature-display">
                <p className="feature-description">
                  {activeFeature.description}
                </p>

                <div className="feature-image">
                  <Image
                    src={activeFeature.image}
                    alt={activeFeature.title}
                    className="display-img"
                    fill
                  />
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default InteractiveFeatureSection;
